<template>
  <v-form ref="form">
    <v-container fluid fill-height>
      <v-row>
        <v-col cols="10" offset="1">
          <h1 class="display-1 font-weight-black text-left">Sign In</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" offset="1">
          <v-row align="center">
          <!-- Card Layout -->
            <v-card class="mx-auto grey lighten-1 elevation-10" min-width="350px" max-width="450px">
              <!-- <v-card-subtitle class="pb-1 text-left title black--text font-weight-bold">
                <v-icon class="mr-3">fas fa-comment</v-icon>Please sign in to submit an application
              </v-card-subtitle> -->
              <v-card-text class="text--primary text-left body-1">
                If you don't have a username and password yet, please contact us.
                We want to be sure we can help you before we ask you to go through
                the trouble of submitting an application with us.
              </v-card-text>
              <v-card-actions class="justify-center">
                <v-btn class="ma-3" text>
                  <v-icon class="mr-3">fas fa-phone</v-icon>
                  +1 (888) 888-8888
                </v-btn>
                <v-btn
                  class="ma-3"
                  color="primary"
                  to="/contact"
                >
                  <v-icon class="mr-3">fas fa-envelope</v-icon>
                  Contact Us Online
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col cols="10" offset="1">
          <v-row align="center">
            <v-card color="mx-auto grey lighten-2" flat max-width="450px">
              <v-btn class="ma-2" text>
                <v-icon class="mr-2">fas fa-phone</v-icon>
                +1 (888) 888-8888
              </v-btn>
              <v-btn
                class="ma-2"
                color="primary"
                to="/contact"
              >
                <v-icon class="mr-2">fas fa-envelope</v-icon>
                Contact Us Online
              </v-btn>
            </v-card>
          </v-row>
        </v-col>
      </v-row> -->
      <v-row>
        <v-col cols="10" offset="1">
          <v-row align="center">
            <v-card
              class="mx-auto pa-4"
              min-width="450px"
              max-width="450px"
              v-if="!challengeState"
            >
              <v-card-title class="font-weight-bold">
                Please sign in to submit an application
              </v-card-title>
              <v-text-field
                label="Username"
                v-model="model.username"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                label="Password"
                v-model="model.password"
                :type="'password'"
                :rules="[rules.required]"
              ></v-text-field>
              <v-card-text
                class="red--text"
                v-if="cognitoExceptionState === 'UserNotFoundException'"
              >
                {{ cognitoExceptionMessage }}
              </v-card-text>
              <v-card-text
                class="red--text"
                v-if="cognitoExceptionState === 'NotAuthorizedException'"
              >
                {{ cognitoExceptionMessage }}
              </v-card-text>
              <v-card-actions class="justify-end">
                <!-- <v-btn color="secondary">Cancel</v-btn> -->
                <v-btn
                  color="primary"
                  @click="signIn(model)"
                  class="px-4"
                >Sign In</v-btn>
              </v-card-actions>
            </v-card>
            <v-card
              class="mx-auto pa-4"
              min-width="350px"
              v-if="challengeState"
            >
              <v-card-title>Update Your Password</v-card-title>
              <v-card-subtitle class="text-left">
                Password requirements<br/>
                - 8 or more characters<br/>
                - an uppercase letter<br/>
                - a lowercase letter<br/>
                - a special character
              </v-card-subtitle>
              <v-text-field
                label="New Password"
                v-model="model.newPassword"
                :type="'password'"
                :rules="[rules.required]"
              ></v-text-field>
              <v-text-field
                label="Confirm Password"
                v-model="model.newPasswordConfirm"
                :type="'password'"
                :rules="[rules.required, rules.passwordConfirmed]"
              ></v-text-field>
              <v-card-text
                class="red--text"
                v-if="cognitoExceptionState === 'InvalidPasswordException'"
              >
                Please choose a more secure password.
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary"
                  @click="updatePassword(model.newPassword)"
                >Update Password</v-btn>
              </v-card-actions>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          {{ challengeState }}
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<style>
</style>

<script>
import { mapState, mapActions } from 'vuex';
import { Auth } from 'aws-amplify';

export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail. ex: email@address.com';
        },
        passwordConfirmed: (value) => {
          if (value.length) {
            return (value === this.model.newPassword) || 'Passwords must match';
          }
          return 'Please choose a password';
        },
      },
      model: {
        username: '',
        password: '',
        newPassword: '',
        newPasswordConfirm: '',
      },
    };
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      challengeState: (state) => state.currentChallengeState,
      cognitoExceptionState: (state) => state.currentCognitoException,
      cognitoExceptionMessage: (state) => state.currentCognitoExceptionMessage,
    }),
  },
  methods: {
    ...mapActions({
      setUser: 'setUser',
      setChallengeState: 'setChallengeState',
      setCognitoException: 'setCognitoException',
    }),
    async signIn(username, password) {
      if (this.$refs.form.validate()) {
        try {
          const user = await Auth.signIn(username, password);
          this.handleChallenge(user);
          // Update current user
          this.setUser(user);
        } catch (error) {
          // Handle sign in error
          this.handleCognitoException(error);
          this.setUser(null);
        }
      }
    },
    async updatePassword(password) {
      try {
        const user = await Auth.completeNewPassword(
          this.currentUser,
          password,
        );
        this.handleChallenge(user);
        // Update current user
        this.setUser(user);
      } catch (error) {
        // Handle password reset error
        this.handleCognitoException(error);
      }
    },
    handleChallenge(user) {
      // Check for challenge
      if (user.challengeName !== null) {
        // Update challenge state
        this.setChallengeState(user.challengeName);
      } else {
        // Update challenge state
        this.setChallengeState(null);
      }
    },
    handleCognitoException(error) {
      if (error.code !== null) {
        this.setCognitoException(error);
      } else {
        this.setCognitoException(null);
      }
    },
  },
};
</script>
